var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topic-block",class:{ error: _vm.mark === 2, correct: _vm.mark === 1, done: _vm.mark === 3 }},[_c('div',{staticClass:"mark"}),_c('div',{staticClass:"topic-number van-ellipsis"},[_vm._v(_vm._s(_vm.indexVal)+"题")])])
}
var staticRenderFns = []

export { render, staticRenderFns }